var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referral-list"},[_c('list',{attrs:{"fs":_vm.referralFields,"api":"referrals","editLink":"/admin/referrals","addLink":"/admin/referrals/new","title":"Referrals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }